/* agwc-orient-fx.js - R13d. THE REASONING IS blocks/agwc-orientation.liquid's
   header; a 4,000 B ceiling holds this file to its traps. Two jobs: STAMP
   `data-agwc-mirror` on every gallery slide and thumb carrying one of the four
   INLINE variants' featured media, and CROSSFADE a clone of the PRE-FLIP
   picture out over slick's own numbers. */
(function () {
  'use strict';

  var API = window.AGWC_ORIENT;
  if (!API || API.fx) return;          /* no control on this page, or armed */

  var GAL = '.slick-product-gallery', TH = '.slick-product-thumbnail';
  var MIR = 'data-agwc-mirror', MEDIA = {}, n = 0, ft = 0, ghost = null;

  function q(s, r) { return (r || document).querySelector(s); }
  function all(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  try {
    (JSON.parse(q('#agwc-orient-data').textContent).media || [])
      .forEach(function (m) { if (m) MEDIA[String(m)] = 1; });
  } catch (e) { MEDIA = {}; }
  API.media = Object.keys(MEDIA);

  /* Idempotent: boot, DCL, load, slick init / reInit, and every pick. A 2.x
     slide is never stamped - a side-by-side photo has no hand. */
  function stamp() {
    var k = 0;
    [GAL, TH].forEach(function (sel) {
      var r = q(sel);
      if (!r) return;
      all('[data-media-id]', r).forEach(function (el) {
        if (MEDIA[el.getAttribute('data-media-id')]) {
          el.setAttribute(MIR, '');
          k++;
        } else el.removeAttribute(MIR);
      });
    });
    API.stamped = k;
    return k;
  }

  /* slick's OWN speed / easing off the LIVE instance; the pair below is the
     measured fallback and API.fxSource names which one ran. */
  function opts() {
    var g = q(GAL), $ = window.jQuery, s = null;
    try {
      s = ($ && g && $(g).slick) ? $(g).slick('getSlick') : null;
    } catch (e) { s = null; }
    if (s && s.options && s.options.speed) {
      API.fxSource = 'slick';
      return [s.options.speed, s.options.cssEase || 'ease'];
    }
    API.fxSource = 'fallback';
    return [500, 'ease'];
  }

  function kill() {
    clearTimeout(ft);
    if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
    ghost = null;
  }

  /* pick() calls this with the PRE-FLIP picture still painted, so the clone's
     inline `transform` is that picture's computed value - and inline beats the
     block's author rule, so the ghost keeps the OLD hand while the real image
     underneath already wears the new one. */
  function fx() {
    stamp();
    var g = q(GAL), slide = g && q('.slick-slide.slick-current', g);
    var img = slide && q('img', slide);
    kill();
    if (!img || !window.matchMedia('(min-width: 992px)').matches) return;
    var o = opts(), sr = slide.getBoundingClientRect();
    var ir = img.getBoundingClientRect(), c = img.cloneNode(false);
    API.fxSpeed = o[0];
    API.fxEase = o[1];
    c.setAttribute('data-agwc-fx', '');
    c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:absolute;z-index:3;pointer-events:none;margin:0'
      + ';left:' + (ir.left - sr.left) + 'px;top:' + (ir.top - sr.top) + 'px'
      + ';width:' + ir.width + 'px;height:' + ir.height + 'px;opacity:1'
      + ';transform:' + (window.getComputedStyle(img).transform || 'none')
      + ';transition:opacity ' + o[0] + 'ms ' + o[1];
    ghost = slide.appendChild(c);
    /* ONE forced reflow, never a rAF: the transition starts in the SAME frame
       as the press, which is what keeps the total one `speed` long. */
    void c.offsetWidth;
    c.style.opacity = '0';
    API.fxN = ++n;
    ft = setTimeout(kill, o[0] + 120);
  }

  API.fx = fx;
  stamp();
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', stamp, false);
    window.addEventListener('load', stamp, false);
  }
  try {
    if (window.jQuery) {
      window.jQuery(document).on('init.agwcfx reInit.agwcfx',
                                 GAL + ', ' + TH, stamp);
    }
  } catch (e) { }
})();
